import {useContext} from 'react';
import HeadingAndExpandableBody from '../UI/HeadingAndExpandableBody';
import {Context} from '../../context';
import {dollarAmount, getDateString} from '../../helperFunctions';

function FareCapping(props) {
  const {localeText, account} = useContext(Context);

  const fareCaps = account?.fareCaps || [];

  // Group fare caps by pot_name
  const groupedFareCaps = fareCaps.reduce((acc, fareCap) => {
    const potName = fareCap.pot_name || 'Unknown';
    if (!acc[potName]) {
      acc[potName] = [];
    }
    acc[potName].push(fareCap);
    return acc;
  }, {});

  const calculatePercentage = (used, cap) => {
    if (!cap || cap === 0) return 0;
    return Math.min((used / cap) * 100, 100);
  };

  return (
    <HeadingAndExpandableBody
      headingAndExpandableBodyId='fare-capping'
      heading={localeText(
        'rw_header_fare_capping_progress',
        'Fare Capping Progress'
      )}
      expanded={props.expanded}
    >
      {Object.keys(groupedFareCaps).length > 0 ? (
        Object.entries(groupedFareCaps).map(([bucketName, caps]) => (
          <div key={bucketName} className='mb-8'>
            <h3 className='font-bold text-lg mb-4'>{bucketName}</h3>
            {caps.map((fareCap, index) => {
              const capAmount = fareCap.cap_amount / 100;
              const progress = fareCap.progress / 100;
              const remaining = Math.max(capAmount - progress, 0);
              const percentage = calculatePercentage(progress, capAmount);

              return (
                <div key={fareCap.pot_id} className='mb-6'>
                  {fareCap.last_reset && (
                    <div className='mb-2'>
                      {localeText('rw_title_last_reset', 'Last Reset')}:{' '}
                      {getDateString(fareCap.last_reset, ['date'])}
                    </div>
                  )}
                  <div className='w-full bg-gray-300 rounded-full h-6 mb-2 relative overflow-hidden'>
                    <div
                      className='bg-blue-600 h-6 rounded-full flex items-center justify-center text-white text-sm font-semibold'
                      style={{width: `${percentage}%`}}
                    >
                      {percentage >= 20 && `${Math.round(percentage)}%`}
                    </div>
                    {percentage < 20 && percentage > 0 && (
                      <div className='absolute inset-0 flex items-center justify-center text-sm font-semibold'>
                        {Math.round(percentage)}%
                      </div>
                    )}
                  </div>
                  <div className='flex justify-between'>
                    <span>
                      {dollarAmount(progress * 100)}{' '}
                      {localeText('rw_title_used', 'Used')}
                    </span>
                    <span>
                      {dollarAmount(remaining * 100)}{' '}
                      {localeText('rw_title_remaining', 'Remaining')} /{' '}
                      {dollarAmount(capAmount * 100)}{' '}
                      {localeText('rw_title_cap', 'Cap')}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        ))
      ) : (
        <p className='text-center text-gray-600'>
          {localeText(
            'rw_msg_no_fare_capping_data',
            'No fare capping data available'
          )}
        </p>
      )}
    </HeadingAndExpandableBody>
  );
}

export default FareCapping;
